// 默认货币
export const DefaultCurrency = 'USD'
// 速卖通平台id
export const AliExpressId = 1
// lazada平台id
export const LazadaId = 2
// 亚马逊平台id
export const AmazonId = 3
// wish平台id
export const WishId = 5
// 虾皮平台id
export const ShopeeId = 11
// 线下平台
export const OfflineId = 0
// 线下平台
export const Wish = 5

// 没有enumerate，使用object模拟
export const PLATFORM_ENUM = {
  aliExpressId: 1,
  1: 'aliExpressId',
  lazadaId: 2,
  2: 'lazadaId',
  amazonId: 3,
  3: 'amazonId',
  shopeeId: 4,
  4: 'shopeeId'
}

// 平台 id map
export const PLATFORM_ID_MAP = {
  aliExpressId: {
    id: AliExpressId, // 1
    englishName: 'Aliexpress',
    name: '速卖通'
  },
  lazadaId: {
    id: LazadaId, // 2
    englishName: 'Lazada',
    name: '拉赞达'
  },
  amazonId: {
    id: AmazonId, // 3
    englishName: 'Amazon',
    name: '亚马逊'
  },
  shopeeId: {
    id: ShopeeId, // 11
    englishName: 'Shopee',
    name: '虾皮'
  }
}

/**
 * 费用导入 的类型
 */
export const FEE_IMPORT_TYPE = {
  system: 'system',
  platform: 'platform',
  order: 'order',
  store: 'store',
  fixedCostSystem: 'fixedCostSystem',
}

/**
 * 费用导入 的类型
 */
export const FEE_IMPORT_TYPE_OBJ = {
  system: {
    id: 'system',
    downloadTemplate: 'EXPENSE_SYSTEM_SKU',
    downloadTemplateDefaultName: '系统SKU费用导入模板.xlsx'
  },
  platform: {
    id: 'platform',
    downloadTemplate: 'EXPENSE_PLATFORM_SKU',
    downloadTemplateDefaultName: '平台SKU费用导入模板.xlsx'
  },
  order: {
    id: 'order',
    downloadTemplate: 'EXPENSE_ORDER_CODE',
    downloadTemplateDefaultName: '订单费用导入模板.xlsx'
  },
  store: {
    id: 'store',
    downloadTemplate: 'EXPENSE_SHOP',
    downloadTemplateDefaultName: '店铺费用导入模板.xlsx'
  },
  fixedCostSystem: {
    id: 'fixedCostSystem',
    downloadTemplate: 'EXPENSE_SYSTEM_SKU_REPLACE',
    downloadTemplateDefaultName: '固定成本导入模板.xlsx'
  },
}

/**
 * 应收明细 的类型
 */
export const RECEIVABLE_IMPORT_TYPE_OBJ = {
  11: {
    id: 11,
    platform: 'shopee',
    downloadTemplate: 'SHOPEE_RECEIVABLE_ADJUSTMENT',
    downloadTemplateDefaultName: 'tpl/shopee_receivable_adjustment_tpl.xlsx'
  },
  2: {
    id: 2,
    platform: 'lazada',
    downloadTemplate: 'LAZADA_RECEIVABLE_ADJUSTMENT',
    downloadTemplateDefaultName: 'tpl/lazada_receivable_adjustment_tpl.xlsx'
  },
  1: {
    id: 1,
    platform: 'aliExpress',
    downloadTemplate: 'ALIEXPRESS_RECEIVABLE_ADJUSTMENT',
    downloadTemplateDefaultName: 'tpl/aliExpress_receivable_adjustment_tpl.xlsx'
  },
}

/**
 * 下载模板 的类型
 */
export const DOWNLOAD_TEMPLATE_TYPE = {
  EXPENSE_PLATFORM_SKU: 'EXPENSE_PLATFORM_SKU'
}

/**
 * 业务日志类型 枚举
 */
export const BIZ_LOG_TYPE_ENUM = {
  /**
   * 费用管理策略
   */
  EXPENSE_STRATEGY: 'EXPENSE_STRATEGY',
  /**
   * 费用管理费用类型
   */
  EXPENSE_FEE_TYPE: 'EXPENSE_FEE_TYPE',
  /**
   * 费用管理订单维度
   */
  EXPENSE_ORDER_CODE: 'EXPENSE_ORDER_CODE',
  /**
   * 费用管理平台SKU维度
   */
  EXPENSE_PLATFORM_SKU: 'EXPENSE_PLATFORM_SKU',
  /**
   * 费用管理店铺维度
   */
  EXPENSE_SHOP: 'EXPENSE_SHOP',
  /**
   * 费用管理系统SKU维度
   */
  SYSTEM_SKU: 'SYSTEM_SKU'
}

// 广告管理-根据站点适配竞价预算
export const mapAccount = [{
  countryCode: 'US',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.75,
},
{
  countryCode: 'CA',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.6,
},
{
  countryCode: 'MX',
  minBudget: 1,
  maxBudget: 21000000,
  minBid: 0.1,
  maxBid: 20000,
  defaultBid: '',
},
{
  countryCode: 'BR',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.07,
  maxBid: 1100,
  defaultBid: '',
},
{
  countryCode: 'UK',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.5,
},
{
  countryCode: 'GB',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.5,
},
{
  countryCode: 'FR',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.4,
},
{
  countryCode: 'DE',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.4,
},
{
  countryCode: 'IT',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.3,
},
{
  countryCode: 'SE',
  minBudget: 9,
  maxBudget: 9300000,
  minBid: 0.18,
  maxBid: 9300,
  defaultBid: 6.9,
},
{
  countryCode: 'PL',
  minBudget: 2,
  minBid: 0.04,
  maxBid: 2000,
  defaultBid: 1.45,
},
{
  countryCode: 'TR',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.05,
  maxBid: 2500,
  defaultBid: '',
},
{
  countryCode: 'NL',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.55,
},
{
  countryCode: 'ES',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1000,
  defaultBid: 0.3,
},
{
  countryCode: 'JP',
  minBudget: 100,
  maxBudget: 21000000,
  minBid: 2,
  maxBid: 100000,
  defaultBid: 40
},
{
  countryCode: 'AU',
  minBudget: 1.4,
  maxBudget: 1500000,
  minBid: 0.1,
  maxBid: 1410,
  defaultBid: 1,
},
{
  countryCode: 'SG',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.02,
  maxBid: 1100,
  defaultBid: '',
},
{
  countryCode: 'IN',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 1,
  maxBid: 5000,
  defaultBid: '',
},
{
  countryCode: 'SA',
  minBudget: 4,
  maxBudget: 3700000,
  minBid: 0.1,
  maxBid: 3670,
  defaultBid: 4,
},
{
  countryCode: 'AE',
  minBudget: 1,
  maxBudget: 1000000,
  minBid: 0.24,
  maxBid: 184,
  defaultBid: '',
},
]
// 国家地图坐标
export const CountryPlatCoord = { AO: { es: 'Angola', cn: '安哥拉', coord: ['17.87', '-11.20'] }, AF: { es: 'Afghanistan', cn: '阿富汗', coord: ['67.71', '33.94'] }, AL: { es: 'Albania', cn: '阿尔巴尼亚', coord: ['20.17', '41.15'] }, DZ: { es: 'Algeria', cn: '阿尔及利亚', coord: ['1.66', '28.03'] }, AD: { es: 'Andorra', cn: '安道尔共和国', coord: ['1.52', '42.51'] }, AI: { es: 'Anguilla', cn: '安圭拉岛', coord: ['-63.07', '18.22'] }, AG: { es: 'Antigua and Barbuda', cn: '安提瓜和巴布达', coord: ['-63.62', '-38.42'] }, AR: { es: 'Argentina', cn: '阿根廷', coord: ['45.04', '40.07'] }, AM: { es: 'Armenia', cn: '亚美尼亚', coord: ['-90.94', '30.20'] }, AU: { es: 'Australia', cn: '澳大利亚', coord: ['14.55', '47.52'] }, AT: { es: 'Austria', cn: '奥地利', coord: ['47.58', '40.14'] }, AZ: { es: 'Azerbaijan', cn: '阿塞拜疆', coord: ['-77.40', '25.03'] }, BS: { es: 'Bahamas', cn: '巴哈马', coord: ['50.56', '26.07'] }, BH: { es: 'Bahrain', cn: '巴林', coord: ['90.36', '23.68'] }, BD: { es: 'Bangladesh', cn: '孟加拉国', coord: ['-59.54', '13.19'] }, BB: { es: 'Barbados', cn: '巴巴多斯', coord: ['27.95', '53.71'] }, BY: { es: 'Belarus', cn: '白俄罗斯', coord: ['4.47', '50.50'] }, BE: { es: 'Belgium', cn: '比利时', coord: ['-88.50', '17.19'] }, BZ: { es: 'Belize', cn: '伯利兹', coord: ['2.32', '9.31'] }, BJ: { es: 'Benin', cn: '贝宁', coord: ['-64.75', '32.31'] }, BM: { es: 'Bermuda Is.', cn: '百慕大群岛', coord: ['-63.59', '-16.29'] }, BO: { es: 'Bolivia', cn: '玻利维亚', coord: ['24.68', '-22.33'] }, BW: { es: 'Botswana', cn: '博茨瓦纳', coord: ['-51.93', '-14.24'] }, BR: { es: 'Brazil', cn: '巴西', coord: ['114.73', '4.54'] }, BN: { es: 'Brunei', cn: '文莱', coord: ['25.49', '42.73'] }, BG: { es: 'Bulgaria', cn: '保加利亚', coord: ['-1.56', '12.24'] }, BF: { es: 'Burkina-faso', cn: '布基纳法索', coord: ['95.96', '21.92'] }, MM: { es: 'Burma', cn: '缅甸', coord: ['29.92', '-3.37'] }, BI: { es: 'Burundi', cn: '布隆迪', coord: ['12.35', '7.37'] }, CM: { es: 'Cameroon', cn: '喀麦隆', coord: ['-106.35', '56.13'] }, CA: { es: 'Canada', cn: '加拿大', coord: ['-117.64', '33.64'] }, CF: { es: 'Central African Republic', cn: '中非共和国', coord: ['18.73', '15.45'] }, TD: { es: 'Chad', cn: '乍得', coord: ['-71.54', '-35.68'] }, CL: { es: 'Chile', cn: '智利', coord: ['104.20', '35.86'] }, CN: { es: 'China', cn: '中国', coord: ['-74.30', '4.57'] }, CO: { es: 'Colombia', cn: '哥伦比亚', coord: ['15.83', '-0.23'] }, CG: { es: 'Congo', cn: '刚果', coord: ['-90.49', '47.61'] }, CK: { es: 'Cook Is.', cn: '库克群岛', coord: ['-83.75', '9.75'] }, CR: { es: 'Costa Rica', cn: '哥斯达黎加', coord: ['15.2', '45.1'] }, CU: { es: 'Cuba', cn: '古巴', coord: ['-77.78', '21.52'] }, CY: { es: 'Cyprus', cn: '塞浦路斯', coord: ['33.43', '35.13'] }, CZ: { es: 'Czech Republic', cn: '捷克', coord: ['15.47', '49.82'] }, DK: { es: 'Denmark', cn: '丹麦', coord: ['9.50', '56.26'] }, DJ: { es: 'Djibouti', cn: '吉布提', coord: ['42.59', '11.83'] }, DO: { es: 'Dominica Rep.', cn: '多米尼加共和国', coord: ['-0.19', '51.52'] }, EC: { es: 'Ecuador', cn: '厄瓜多尔', coord: ['-78.18', '-1.83'] }, EG: { es: 'Egypt', cn: '埃及', coord: ['30.80', '26.82'] }, SV: { es: 'EI Salvador', cn: '萨尔瓦多', coord: ['-88.90', '13.79'] }, EE: { es: 'Estonia', cn: '爱沙尼亚', coord: ['25.01', '58.60'] }, ET: { es: 'Ethiopia', cn: '埃塞俄比亚', coord: ['40.49', '9.15'] }, FJ: { es: 'Fiji', cn: '斐济', coord: ['178.07', '-17.71'] }, FI: { es: 'Finland', cn: '芬兰', coord: ['25.75', '61.92'] }, FR: { es: 'France', cn: '法国', coord: ['2.21', '46.23'] }, GF: { es: 'French Guiana', cn: '法属圭亚那', coord: ['-53.13', '3.93'] }, GA: { es: 'Gabon', cn: '加蓬', coord: ['11.61', '-0.80'] }, GM: { es: 'Gambia', cn: '冈比亚', coord: ['-15.31', '13.44'] }, GE: { es: 'Georgia', cn: '格鲁吉亚', coord: ['-82.90', '32.17'] }, DE: { es: 'Germany', cn: '德国', coord: ['10.45', '51.17'] }, GH: { es: 'Ghana', cn: '加纳', coord: ['-1.02', '7.95'] }, GI: { es: 'Gibraltar', cn: '直布罗陀', coord: ['-5.35', '36.14'] }, GR: { es: 'Greece', cn: '希腊', coord: ['21.82', '39.07'] }, GD: { es: 'Grenada', cn: '格林纳达', coord: ['-61.68', '12.12'] }, GU: { es: 'Guam', cn: '关岛', coord: ['144.79', '13.44'] }, GT: { es: 'Guatemala', cn: '危地马拉', coord: ['-90.23', '15.78'] }, GN: { es: 'Guinea', cn: '几内亚', coord: ['-9.70', '9.95'] }, GY: { es: 'Guyana', cn: '圭亚那', coord: ['-58.93', '4.86'] }, HT: { es: 'Haiti', cn: '海地', coord: ['-72.29', '18.97'] }, HN: { es: 'Honduras', cn: '洪都拉斯', coord: ['-86.24', '15.20'] }, HK: { es: 'Hongkong', cn: '香港', coord: ['114.11', '22.40'] }, HU: { es: 'Hungary', cn: '匈牙利', coord: ['19.50', '47.16'] }, IS: { es: 'Iceland', cn: '冰岛', coord: ['-19.02', '64.96'] }, IN: { es: 'India', cn: '印度', coord: ['78.96', '20.59'] }, ID: { es: 'Indonesia', cn: '印度尼西亚', coord: ['113.92', '-0.79'] }, IR: { es: 'Iran', cn: '伊朗', coord: ['53.69', '32.43'] }, IQ: { es: 'Iraq', cn: '伊拉克', coord: ['43.68', '33.22'] }, IE: { es: 'Ireland', cn: '爱尔兰', coord: ['-8.24', '53.41'] }, IL: { es: 'Israel', cn: '以色列', coord: ['34.85', '31.05'] }, IT: { es: 'Italy', cn: '意大利', coord: ['12.57', '41.87'] }, JM: { es: 'Jamaica', cn: '牙买加', coord: ['-77.30', '18.11'] }, JP: { es: 'Japan', cn: '日本', coord: ['138.25', '36.20'] }, JO: { es: 'Jordan', cn: '约旦', coord: ['36.24', '30.59'] }, KH: { es: 'Kampuchea', cn: '柬埔寨', coord: ['105.46', '12.00'] }, KZ: { es: 'Kazakstan', cn: '哈萨克斯坦', coord: ['66.92', '48.02'] }, KE: { es: 'Kenya', cn: '肯尼亚', coord: ['37.91', '-0.02'] }, KR: { es: 'Korea', cn: '韩国', coord: ['127.98', '37.66'] }, KW: { es: 'Kuwait', cn: '科威特', coord: ['47.48', '29.31'] }, KG: { es: 'Kyrgyzstan', cn: '吉尔吉斯坦', coord: ['74.77', '41.20'] }, LA: { es: 'Laos', cn: '老挝', coord: ['102.50', '19.86'] }, LV: { es: 'Latvia', cn: '拉脱维亚', coord: ['24.60', '56.88'] }, LB: { es: 'Lebanon', cn: '黎巴嫩', coord: ['35.86', '33.85'] }, LS: { es: 'Lesotho', cn: '莱索托', coord: ['28.23', '-29.61'] }, LR: { es: 'Liberia', cn: '利比里亚', coord: ['-9.43', '6.43'] }, LY: { es: 'Libya', cn: '利比亚', coord: ['17.23', '26.34'] }, LI: { es: 'Liechtenstein', cn: '列支敦士登', coord: ['9.56', '47.17'] }, LT: { es: 'Lithuania', cn: '立陶宛', coord: ['23.88', '55.17'] }, LU: { es: 'Luxembourg', cn: '卢森堡', coord: ['6.13', '49.82'] }, MO: { es: 'Macao', cn: '澳门', coord: ['113.54', '22.20'] }, MG: { es: 'Madagascar', cn: '马达加斯加', coord: ['46.87', '-18.77'] }, MW: { es: 'Malawi', cn: '马拉维', coord: ['34.30', '-13.25'] }, MY: { es: 'Malaysia', cn: '马来西亚', coord: ['101.98', '4.21'] }, MV: { es: 'Maldives', cn: '马尔代夫', coord: ['73.54', '1.98'] }, ML: { es: 'Mali', cn: '马里', coord: ['-4.00', '17.57'] }, MT: { es: 'Malta', cn: '马耳他', coord: ['14.38', '35.94'] }, MU: { es: 'Mauritius', cn: '毛里求斯', coord: ['57.55', '-20.35'] }, MX: { es: 'Mexico', cn: '墨西哥', coord: ['-102.55', '23.63'] }, MC: { es: 'Monaco', cn: '摩纳哥', coord: ['7.42', '43.74'] }, MN: { es: 'Mongolia', cn: '蒙古', coord: ['103.85', '46.86'] }, MS: { es: 'Montserrat Is', cn: '蒙特塞拉特岛', coord: ['-62.19', '16.74'] }, MA: { es: 'Morocco', cn: '摩洛哥', coord: ['-7.09', '31.79'] }, MZ: { es: 'Mozambique', cn: '莫桑比克', coord: ['35.53', '-18.67'] }, NA: { es: 'Namibia', cn: '纳米比亚', coord: ['18.49', '-22.96'] }, NR: { es: 'Nauru', cn: '瑙鲁', coord: ['166.93', '-0.52'] }, NP: { es: 'Nepal', cn: '尼泊尔', coord: ['84.12', '28.39'] }, NL: { es: 'Netherlands', cn: '荷兰', coord: ['5.29', '52.13'] }, NZ: { es: 'New Zealand', cn: '新西兰', coord: ['174.89', '-40.90'] }, NI: { es: 'Nicaragua', cn: '尼加拉瓜', coord: ['-85.21', '12.87'] }, NE: { es: 'Niger', cn: '尼日尔', coord: ['8.08', '17.61'] }, NG: { es: 'Nigeria', cn: '尼日利亚', coord: ['8.68', '9.08'] }, KP: { es: 'North Korea', cn: '朝鲜', coord: ['127.51', '40.34'] }, NO: { es: 'Norway', cn: '挪威', coord: ['8.47', '60.47'] }, OM: { es: 'Oman', cn: '阿曼', coord: ['55.98', '21.47'] }, PK: { es: 'Pakistan', cn: '巴基斯坦', coord: ['69.35', '30.38'] }, PA: { es: 'Panama', cn: '巴拿马', coord: ['-80.78', '8.54'] }, PG: { es: 'Papua New Cuinea', cn: '巴布亚新几内亚', coord: ['143.96', '-6.31'] }, PY: { es: 'Paraguay', cn: '巴拉圭', coord: ['-58.44', '-23.44'] }, PE: { es: 'Peru', cn: '秘鲁', coord: ['-75.02', '-9.19'] }, PH: { es: 'Philippines', cn: '菲律宾', coord: ['121.77', '12.88'] }, PL: { es: 'Poland', cn: '波兰', coord: ['19.15', '51.92'] }, PF: { es: 'French Polynesia', cn: '法属玻利尼西亚', coord: ['-149.41', '-17.68'] }, PT: { es: 'Portugal', cn: '葡萄牙', coord: ['-8.22', '39.40'] }, PR: { es: 'Puerto Rico', cn: '波多黎各', coord: ['-66.59', '18.22'] }, QA: { es: 'Qatar', cn: '卡塔尔', coord: ['51.18', '25.35'] }, RO: { es: 'Romania', cn: '罗马尼亚', coord: ['24.97', '45.94'] }, RU: { es: 'Russia', cn: '俄罗斯', coord: ['105.32', '61.52'] }, LC: { es: 'St.Lucia', cn: '圣卢西亚', coord: ['-60.98', '13.91'] }, VC: { es: 'St.Vincent', cn: '圣文森特', coord: ['-91.06', '29.99'] }, SM: { es: 'San Marino', cn: '圣马力诺', coord: ['12.46', '43.94'] }, ST: { es: 'Sao Tome and Principe', cn: '圣多美和普林西比', coord: ['6.61', '0.19'] }, SA: { es: 'Saudi Arabia', cn: '沙特阿拉伯', coord: ['45.08', '23.89'] }, SN: { es: 'Senegal', cn: '塞内加尔', coord: ['-14.45', '14.50'] }, SC: { es: 'Seychelles', cn: '塞舌尔', coord: ['55.49', '-4.68'] }, SL: { es: 'Sierra Leone', cn: '塞拉利昂', coord: ['-11.78', '8.46'] }, SG: { es: 'Singapore', cn: '新加坡', coord: ['103.82', '1.35'] }, SK: { es: 'Slovakia', cn: '斯洛伐克', coord: ['19.70', '48.67'] }, SI: { es: 'Slovenia', cn: '斯洛文尼亚', coord: ['15.00', '46.15'] }, SB: { es: 'Solomon Is', cn: '所罗门群岛', coord: ['-97.37', '38.92'] }, SO: { es: 'Somali', cn: '索马里', coord: ['46.20', '5.15'] }, ZA: { es: 'South Africa', cn: '南非', coord: ['22.94', '-30.56'] }, ES: { es: 'Spain', cn: '西班牙', coord: ['-3.75', '40.46'] }, LK: { es: 'Sri Lanka', cn: '斯里兰卡', coord: ['80.77', '7.87'] }, SD: { es: 'Sudan', cn: '苏丹', coord: ['30.22', '12.86'] }, SR: { es: 'Suriname', cn: '苏里南', coord: ['-56.03', '3.92'] }, SZ: { es: 'Swaziland', cn: '斯威士兰', coord: ['31.47', '-26.52'] }, SE: { es: 'Sweden', cn: '瑞典', coord: ['18.64', '60.13'] }, CH: { es: 'Switzerland', cn: '瑞士', coord: ['8.23', '46.82'] }, SY: { es: 'Syria', cn: '叙利亚', coord: ['39.00', '34.80'] }, TW: { es: 'Taiwan', cn: '台湾省', coord: ['120.96', '23.70'] }, TJ: { es: 'Tajikstan', cn: '塔吉克斯坦', coord: ['71.28', '38.86'] }, TZ: { es: 'Tanzania', cn: '坦桑尼亚', coord: ['34.89', '-6.37'] }, TH: { es: 'Thailand', cn: '泰国', coord: ['100.99', '15.87'] }, TG: { es: 'Togo', cn: '多哥', coord: ['0.82', '8.62'] }, TO: { es: 'Tonga', cn: '汤加', coord: ['-175.20', '-21.18'] }, TT: { es: 'Trinidad and Tobago', cn: '特立尼达和多巴哥', coord: ['-61.22', '10.69'] }, TN: { es: 'Tunisia', cn: '突尼斯', coord: ['9.54', '33.89'] }, TR: { es: 'Turkey', cn: '土耳其', coord: ['35.24', '38.96'] }, TM: { es: 'Turkmenistan', cn: '土库曼斯坦', coord: ['59.56', '38.97'] }, UG: { es: 'Uganda', cn: '乌干达', coord: ['32.29', '1.37'] }, UA: { es: 'Ukraine', cn: '乌克兰', coord: ['31.17', '48.38'] }, AE: { es: 'United Arab Emirates', cn: '阿拉伯联合酋长国', coord: ['53.85', '23.42'] }, GB: { es: 'United Kiongdom', cn: '英国', coord: ['-3.44', '55.38'] }, US: { es: 'United States of America', cn: '美国', coord: ['-95.71', '37.09'] }, UY: { es: 'Uruguay', cn: '乌拉圭', coord: ['-55.77', '-32.52'] }, UZ: { es: 'Uzbekistan', cn: '乌兹别克斯坦', coord: ['64.59', '41.38'] }, VE: { es: 'Venezuela', cn: '委内瑞拉', coord: ['-66.59', '6.42'] }, VN: { es: 'Vietnam', cn: '越南', coord: ['108.28', '14.06'] }, YE: { es: 'Yemen', cn: '也门', coord: ['48.52', '15.55'] }, YU: { es: 'Yugoslavia', cn: '南斯拉夫', coord: ['121.02', '14.48'] }, ZW: { es: 'Zimbabwe', cn: '津巴布韦', coord: ['29.15', '-19.02'] }, ZR: { es: 'Zaire', cn: '扎伊尔', coord: ['21.76', '-4.04'] }, ZM: { es: 'Zambia', cn: '赞比亚', coord: ['27.85', '-13.13'] } }
